import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'vvc-loading-panel',
  templateUrl: './loading-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingPanelComponent {

}
